import gql from "graphql-tag"
import { createPaginator, flattenEdges } from "../../../utils/apollo"
import { createPathFromItems } from "../../utils"

import { graphql } from "@apollo/client/react/hoc"
import get from "lodash/get"
import { SchoolFragmentDoc } from "@pathwright/graphql-client/src/generated"

export const PathQuery = gql`
  query PathItemsQuery($id: Int!, $school_id: Int!, $cursor: String) {
    context(school_id: $school_id) {
      school {
        ...School
        pathItems(path_id: $id, first: 1000, after: $cursor) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              order
              name
              type
              path_id
              source_id
              parent_id
              description
              content_id
              assignment_type
              item_content_type_id
              verb
              step_verb: verb
              points
              userpoints_value: points
              is_previewable
              is_required
              time_to_complete
              context {
                school_id
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
`

export default graphql(PathQuery, {
  // requires path id
  options: ({ pathId, schoolId }) => ({
    variables: {
      id: pathId,
      school_id: schoolId
    }
  }),
  // map data to props
  props: ({ data }) => {
    const { error, loading } = data
    return {
      error,
      loading,
      items: createPathFromItems(
        flattenEdges(get(data, "context.school.pathItems") || [])
      ),
      hasMore: get(data, "context.school.pathItems.pageInfo.hasNextPage"),
      loadMore: createPaginator(data, "context.school.pathItems")
    }
  }
})
